export default __webpack_public_path__ + "static/media/casaduana_tecnologia.f5e67911.png";